import React, { useEffect, useState } from 'react';
import Gallery from 'react-photo-gallery';

import image1 from '../../assets/images/RandDImages/RD-1.jpg';
import image2 from '../../assets/images/RandDImages/RD-2.jpeg';
import image3 from '../../assets/images/RandDImages/RD-3.jpeg';
import image4 from '../../assets/images/RandDImages/RD-4.JPG';

const imageSources = [image1, image2, image3, image4];

function RandDGallery() {
  const [photos, setPhotos] = useState([]);
  

  useEffect(() => {
    const loadImages = async () => {
      const loadedImages = await Promise.all(
        imageSources.map(
          src =>
            new Promise(resolve => {
              const img = new Image();
              img.src = src;
              img.onload = () => {
                resolve({ src, width: img.naturalWidth, height: img.naturalHeight });
              };
            })
        )
      );
      setPhotos(loadedImages);
    };

    loadImages();
  }, []);

  return (
    <div className="container py-50">
         <h2 className="text-center py-20">Our R&D Gallery</h2>
      {photos.length > 0 && <Gallery photos={photos} />}
    </div>
  );
}

export default RandDGallery;
